export default __webpack_public_path__ + "static/media/operator-phone.b314d62b.svg";